<template>
  <b-row>
    <b-col cols="12">
      <karma-category-add-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import KarmaCategoryAddForm from './KarmaCategoryAddForm.vue'

export default {
  components: {
    BRow,
    BCol,
    KarmaCategoryAddForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
